/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Department,
    DepartmentFromJSON,
    DepartmentFromJSONTyped,
    DepartmentToJSON,
} from './Department';
import {
    DisciplineGroup,
    DisciplineGroupFromJSON,
    DisciplineGroupFromJSONTyped,
    DisciplineGroupToJSON,
} from './DisciplineGroup';
import {
    LearningCompetence,
    LearningCompetenceFromJSON,
    LearningCompetenceFromJSONTyped,
    LearningCompetenceToJSON,
} from './LearningCompetence';
import {
    StudyPlanStatusEnum,
    StudyPlanStatusEnumFromJSON,
    StudyPlanStatusEnumFromJSONTyped,
    StudyPlanStatusEnumToJSON,
} from './StudyPlanStatusEnum';
import {
    StudyPlanStatusHistory,
    StudyPlanStatusHistoryFromJSON,
    StudyPlanStatusHistoryFromJSONTyped,
    StudyPlanStatusHistoryToJSON,
} from './StudyPlanStatusHistory';
import {
    StudyProgram,
    StudyProgramFromJSON,
    StudyProgramFromJSONTyped,
    StudyProgramToJSON,
} from './StudyProgram';
import {
    Subject,
    SubjectFromJSON,
    SubjectFromJSONTyped,
    SubjectToJSON,
} from './Subject';

/**
 * 
 * @export
 * @interface StudyPlan
 */
export interface StudyPlan {
    /**
     * 
     * @type {string}
     * @memberof StudyPlan
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof StudyPlan
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StudyPlan
     */
    updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof StudyPlan
     */
    planYear?: number;
    /**
     * 
     * @type {StudyPlanStatusEnum}
     * @memberof StudyPlan
     */
    status?: StudyPlanStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof StudyPlan
     */
    approvalDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof StudyPlan
     */
    studyProgramId?: string;
    /**
     * 
     * @type {StudyProgram}
     * @memberof StudyPlan
     */
    studyProgram?: StudyProgram;
    /**
     * 
     * @type {string}
     * @memberof StudyPlan
     */
    departmentId?: string | null;
    /**
     * 
     * @type {Department}
     * @memberof StudyPlan
     */
    department?: Department;
    /**
     * 
     * @type {string}
     * @memberof StudyPlan
     */
    mission?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyPlan
     */
    objective?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyPlan
     */
    ocupationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyPlan
     */
    codCOR?: string | null;
    /**
     * 
     * @type {Array<LearningCompetence>}
     * @memberof StudyPlan
     */
    learningCompetences?: Array<LearningCompetence> | null;
    /**
     * 
     * @type {Array<Subject>}
     * @memberof StudyPlan
     */
    subjects?: Array<Subject> | null;
    /**
     * 
     * @type {Array<DisciplineGroup>}
     * @memberof StudyPlan
     */
    groups?: Array<DisciplineGroup> | null;
    /**
     * 
     * @type {Array<StudyPlanStatusHistory>}
     * @memberof StudyPlan
     */
    statusHistory?: Array<StudyPlanStatusHistory> | null;
}

export function StudyPlanFromJSON(json: any): StudyPlan {
    return StudyPlanFromJSONTyped(json, false);
}

export function StudyPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudyPlan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'planYear': !exists(json, 'planYear') ? undefined : json['planYear'],
        'status': !exists(json, 'status') ? undefined : StudyPlanStatusEnumFromJSON(json['status']),
        'approvalDate': !exists(json, 'approvalDate') ? undefined : (new Date(json['approvalDate'])),
        'studyProgramId': !exists(json, 'studyProgramId') ? undefined : json['studyProgramId'],
        'studyProgram': !exists(json, 'studyProgram') ? undefined : StudyProgramFromJSON(json['studyProgram']),
        'departmentId': !exists(json, 'departmentId') ? undefined : json['departmentId'],
        'department': !exists(json, 'department') ? undefined : DepartmentFromJSON(json['department']),
        'mission': !exists(json, 'mission') ? undefined : json['mission'],
        'objective': !exists(json, 'objective') ? undefined : json['objective'],
        'ocupationName': !exists(json, 'ocupationName') ? undefined : json['ocupationName'],
        'codCOR': !exists(json, 'codCOR') ? undefined : json['codCOR'],
        'learningCompetences': !exists(json, 'learningCompetences') ? undefined : (json['learningCompetences'] === null ? null : (json['learningCompetences'] as Array<any>).map(LearningCompetenceFromJSON)),
        'subjects': !exists(json, 'subjects') ? undefined : (json['subjects'] === null ? null : (json['subjects'] as Array<any>).map(SubjectFromJSON)),
        'groups': !exists(json, 'groups') ? undefined : (json['groups'] === null ? null : (json['groups'] as Array<any>).map(DisciplineGroupFromJSON)),
        'statusHistory': !exists(json, 'statusHistory') ? undefined : (json['statusHistory'] === null ? null : (json['statusHistory'] as Array<any>).map(StudyPlanStatusHistoryFromJSON)),
    };
}

export function StudyPlanToJSON(value?: StudyPlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'planYear': value.planYear,
        'status': StudyPlanStatusEnumToJSON(value.status),
        'approvalDate': value.approvalDate === undefined ? undefined : (value.approvalDate.toISOString()),
        'studyProgramId': value.studyProgramId,
        'studyProgram': StudyProgramToJSON(value.studyProgram),
        'departmentId': value.departmentId,
        'department': DepartmentToJSON(value.department),
        'mission': value.mission,
        'objective': value.objective,
        'ocupationName': value.ocupationName,
        'codCOR': value.codCOR,
        'learningCompetences': value.learningCompetences === undefined ? undefined : (value.learningCompetences === null ? null : (value.learningCompetences as Array<any>).map(LearningCompetenceToJSON)),
        'subjects': value.subjects === undefined ? undefined : (value.subjects === null ? null : (value.subjects as Array<any>).map(SubjectToJSON)),
        'groups': value.groups === undefined ? undefined : (value.groups === null ? null : (value.groups as Array<any>).map(DisciplineGroupToJSON)),
        'statusHistory': value.statusHistory === undefined ? undefined : (value.statusHistory === null ? null : (value.statusHistory as Array<any>).map(StudyPlanStatusHistoryToJSON)),
    };
}

